import { useEffect } from 'react';

export interface ShortcutOptions {
  key: string;
  metaKey?: boolean;
  ctrlKey?: boolean;
  onTrigger: () => void;
  enabled?: boolean;
}

export const useKeyboardShortcut = (opts: ShortcutOptions): void => {
  useEffect(() => {
    if (opts.enabled === false) return;
    const handler = (e: KeyboardEvent) => {
      const isMod = (opts.metaKey && e.metaKey) || (opts.ctrlKey && e.ctrlKey);
      if (isMod && e.key.toLowerCase() === opts.key.toLowerCase()) {
        e.preventDefault();
        opts.onTrigger();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [opts.key, opts.metaKey, opts.ctrlKey, opts.onTrigger, opts.enabled]);
};
